import styled, { css } from 'styled-components';
import Styled from 'components/Card/styles';
import { zIndex } from 'styles';

const CUBIC_BEZIER = 'cubic-bezier(0.77, 0, 0.175, 1)'; // custom, not in tokens
const TRANSITION_TOP = `top 0.4s ${CUBIC_BEZIER}`;
const TRANSITION_LEFT = `left 0.4s ${CUBIC_BEZIER}`;
const TRANSITION_HEIGHT = `height 0.4s ${CUBIC_BEZIER}`;
const TRANSITION_OPACITY = `opacity 0.3s ${CUBIC_BEZIER}`;
const TRANSITION_BOX_SHADOW = 'box-shadow 0.1s ease-in 0.1s';

const CardCollection = styled.div`
  ${({ rowHeight }) =>
    rowHeight &&
    css`
      ${Styled.CardContainer} {
        min-height: ${rowHeight}px;
      }
    `}
  /** React Grid Layout styles */
  .react-grid-layout {
    position: relative;
    ${({ $disableAnimation }) => !$disableAnimation &&
    css`
      transition: ${TRANSITION_BOX_SHADOW}, ${TRANSITION_TOP}, ${TRANSITION_LEFT},
        transform ${({ animationDuration }) => `${animationDuration}s`} ${CUBIC_BEZIER}, ${TRANSITION_HEIGHT};
    `}
    .react-grid-item {
      ${({ $disableAnimation }) => !$disableAnimation &&
      css`
        transition: ${TRANSITION_BOX_SHADOW}, ${TRANSITION_TOP}, ${TRANSITION_LEFT},
          transform ${({ animationDuration }) => `${animationDuration}s`} ${CUBIC_BEZIER}, ${TRANSITION_HEIGHT};
      `}
    }

    .react-grid-item.cssTransforms {
      will-change: height, top, left, transform;
    }

    .react-grid-item.react-draggable-dragging {
      cursor: move;
      ${({ $disableAnimation }) => !$disableAnimation &&
      css`
        transition: ${TRANSITION_OPACITY};
      `}
      opacity: 0.7;
      will-change: top, left, opacity, transform;
      z-index: ${zIndex.CARD.dragging};
    }
    .react-grid-item.react-grid-placeholder {
      opacity: 0;
      ${({ $disableAnimation }) => !$disableAnimation &&
      css`
        transition: ${TRANSITION_OPACITY};
      `}
      user-select: none;
      z-index: ${zIndex.CARD.placeholder};
      -moz-user-select: none;
      -ms-user-select: none;
      -o-user-select: none;
      -webkit-user-select: none;
    }
  }
`;

const styles = {
  CardCollection
};

export { styles as default };
